import { AlertModal, ConfirmationModal, Text, useOpenModal } from '@modusign/design-system';
import { noop } from 'lodash';
import moment from 'moment';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

export default function useOpenPurgeDurationGuideModal() {
  const history = useHistory();
  const { pathname } = useLocation();

  const openModal = useOpenModal();

  return useCallback(
    (leavedAt: string) => {
      const purgeProcessingDate = moment(leavedAt).add(30, 'days');

      if (moment().isSameOrAfter(purgeProcessingDate)) {
        openModal((props) => (
          <AlertModal
            {...props}
            maxWidth="xs"
            title="로그인 안내"
            variant="warning"
            onClose={() => {
              props.onClose();
              if (pathname !== '/authentication/signin') {
                history.replace('/authentication/signin');
              }
            }}
          >
            <Text textAlign="center">
              입력한 이메일은 탈퇴한 계정입니다.
              <br />
              <Text color="textEmphasisBase">{`${purgeProcessingDate
                .clone()
                .add(1, 'day')
                .format('ll')}부터`}</Text>{' '}
              해당 이메일 주소로 재가입할 수 있습니다.
            </Text>
          </AlertModal>
        ));
      } else if (moment().isBefore(purgeProcessingDate)) {
        openModal((props) => (
          <ConfirmationModal
            {...props}
            closeButtonLabel="확인"
            confirmButtonClassName="tagContactButton"
            confirmButtonLabel="상담원 연결"
            maxWidth="xs"
            title="로그인 안내"
            variant="warning"
            onClose={() => {
              props.onClose();
              if (pathname !== '/authentication/signin') {
                history.replace('/authentication/signin');
              }
            }}
            onConfirm={noop}
          >
            <Text textAlign="center">
              입력한 이메일은 탈퇴한 계정입니다. <br />{' '}
              <Text color="textEmphasisBase">{`${purgeProcessingDate
                .clone()
                .subtract(1, 'day')
                .format('ll')}까지`}</Text>{' '}
              상담을 통해 계정을 복구할 수 있습니다.
            </Text>
          </ConfirmationModal>
        ));
      }
    },
    [openModal, history, pathname]
  );
}
